import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { StructuredData } from './components/StructuredData';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { Book } from './pages/Book';
import { Programs } from './pages/Programs';
import { SpeedSchool } from './pages/SpeedSchool';
import { Fall2026 } from './pages/Fall2026';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Enroll } from './pages/Enroll';
import { NotFound } from './pages/NotFound';
export function App() {
  return <Router data-id="element-0" data-mp="31c9w477kb5t1">
      <StructuredData data-id="element-1" data-mp="31c1iue7j1yhb" />
      <Layout data-id="element-2" data-mp="2wk08wyxu0jug">
        <Routes data-id="element-3" data-mp="2wk9xqj754kyk">
          <Route path="/" element={<Home data-id="element-5" data-mp="2wiffxdr618yp" />} data-id="element-4" data-mp="2wjql9i09eorx" />
          <Route path="/programs" element={<Programs data-id="element-7" data-mp="28u5vaf5our95" />} data-id="element-6" data-mp="2whxabqim5ie4" />
          <Route path="/speed-school" element={<SpeedSchool data-id="element-9" data-mp="28sbbx5a2f776" />} data-id="element-8" data-mp="28te3lff7pdo5" />
          <Route path="/fall-2026" element={<Fall2026 data-id="element-11" data-mp="23u9vyt7xrnzx" />} data-id="element-10" data-mp="23vkvggucm9l8" />
          <Route path="/about" element={<About data-id="element-13" data-mp="3ijxnsm94vshs" />} data-id="element-12" data-mp="23v2sz2h3ez4v" />
          <Route path="/pricing" element={<Pricing data-id="element-15" data-mp="3ijfwm41bw4gq" />} data-id="element-14" data-mp="3ikh5c1uvgeva" />
          <Route path="/contact" element={<Contact data-id="element-17" data-mp="3mlat8v8bdto6" />} data-id="element-16" data-mp="3ihv0wb3a2fha" />
          <Route path="/book" element={<Book data-id="element-19" data-mp="3mjq2lgp4euvl" />} data-id="element-18" data-mp="3mkhn9wh6j873" />
          <Route path="/enroll" element={<Enroll data-id="element-21" data-mp="3rbrc4uuwm7hx" />} data-id="element-20" data-mp="3mj6j3vjtnyfg" />
          <Route path="*" element={<NotFound data-id="element-23" data-mp="3rd18nfm3z7mg" />} data-id="element-22" data-mp="3rdkisa5iorpx" />
        </Routes>
      </Layout>
    </Router>;
}